// extracted by mini-css-extract-plugin
export default {"backButton":"BackButton-module_backButton_fb8b28","backButtonContainer":"BackButton-module_backButtonContainer_b963ef"};